module.exports = "https://static.wagwalking.com/_next/static/images/pet-insurer-pug-3c970f1ef9f57ba626393ea9908224e2.png";